import { HeartBank } from "../../managers/HeartBank.ts";
import { Crystal3B } from "../../models/Crystal.ts";
import template from "./hb-main.mjs";
import { render } from "lit-html";
import { User } from "firebase/auth";
import { isDesktop, wait } from "../global.ts";
import { Kiitti, Moment } from "../../models/Kiitti.ts";
import { Token, Tokens } from "../../models/Thanks.ts";
import { Functions } from "../../managers/Functions.ts";

import { HbB } from "./hb-b/hb-b.ts";
import { HbVault } from "./hb-vault/hb-vault.ts";
import { HbMine } from "./hb-mine/hb-mine.ts";
import { HbDear } from "./hb-dear/hb-dear.ts";

import { HbVideo } from "./hb-video/hb-video.ts";
import { HbPopup } from "./hb-popup/hb-popup.ts";
import { HbDialog } from "./hb-dialog/hb-dialog.ts";

import { HbShip } from "./hb-ship/hb-ship.ts";
import { HbSilver } from "./hb-silver/hb-silver.ts";
import { HbJewel } from "./hb-jewel/hb-jewel.ts";
import { HbX } from "./hb-x/hb-x.ts";

import { HbLeaderboard } from "./hb-leaderboard/hb-leaderboard.ts";
import { HbThank } from "./hb-thank/hb-thank.ts";
import { HbToken } from "./hb-token/hb-token.ts";

import { HbPixxiKat } from "./hb-pixxikat/hb-pixxikat.ts";
import { HbEmoji } from "./hb-emoji/hb-emoji.ts";
import { HbGif } from "./hb-gif/hb-gif.ts";
import { HbLink } from "./hb-link/hb-link.ts";
import { HbPost } from "./hb-post/hb-post.ts";
import { HbTrove } from "./hb-trove/hb-trove.ts";

customElements.define("hb-b", HbB);
customElements.define("hb-vault", HbVault);
customElements.define("hb-mine", HbMine);
customElements.define("hb-dear", HbDear);

customElements.define("hb-video", HbVideo);
customElements.define("hb-popup", HbPopup);
customElements.define("hb-dialog", HbDialog);

customElements.define("hb-ship", HbShip);
customElements.define("hb-silver", HbSilver);
customElements.define("hb-jewel", HbJewel);
customElements.define("hb-x", HbX);

customElements.define("hb-leaderboard", HbLeaderboard);
customElements.define("hb-thank", HbThank);
customElements.define("hb-token", HbToken);

customElements.define("hb-pixxikat", HbPixxiKat);
customElements.define("hb-emoji", HbEmoji);
customElements.define("hb-gif", HbGif);
customElements.define("hb-post", HbPost);
customElements.define("hb-link", HbLink);
customElements.define("hb-trove", HbTrove);

export class HbMain extends HTMLElement {
    private heartbank = new HeartBank();
    private functions = new Functions();
    private kiitti = new Kiitti();
    private tokens = new Tokens();
    private crystal: Crystal3B;
    private b3: HTMLCanvasElement;
    private spinner: HTMLElement;

    private b: HbB;
    private vault: HbVault;
    private mine: HbMine;
    private dear: HbDear;

    private video: HbVideo;
    private popup: HbPopup;

    private ship: HbShip;
    private silver: HbSilver;
    private jewel: HbJewel;
    private x: HbX;

    private leaderboard: HbLeaderboard;
    private thank: HbThank;
    private token: HbToken;

    private pixxikat: HbPixxiKat;
    private emoji: HbEmoji;
    private gif: HbGif;
    private post: HbPost;
    private link: HbLink;
    private trove: HbTrove;

    constructor() {
        super();
        render(template(null), this);

        this.b3 = this.querySelector("canvas")!;
        this.spinner = this.querySelector("#hb-main-spinner")!;
        this.crystal = new Crystal3B(this.b3);

        this.b = this.querySelector("hb-b")!;
        this.vault = this.querySelector("hb-vault")!;
        this.mine = this.querySelector("hb-mine")!;
        this.dear = this.querySelector("hb-dear")!;

        this.video = this.querySelector("hb-video")!;
        this.popup = this.querySelector("hb-popup")!;

        this.ship = this.querySelector("hb-ship")!;
        this.silver = this.querySelector("hb-silver")!;
        this.jewel = this.querySelector("hb-jewel")!;
        this.x = this.querySelector("hb-x")!;

        this.leaderboard = this.querySelector("hb-leaderboard")!;
        this.thank = this.querySelector("hb-thank")!;
        this.token = this.querySelector("hb-token")!;

        this.pixxikat = this.querySelector("hb-pixxikat")!;
        this.emoji = this.querySelector("hb-emoji")!;
        this.gif = this.querySelector("hb-gif")!;
        this.post = this.querySelector("hb-post")!;
        this.link = this.querySelector("hb-link")!;
        this.trove = this.querySelector("hb-trove")!;
    }

    connectedCallback() {
        this.crystal.init(isDesktop ? window.innerHeight : window.innerWidth);
        //this.showCrystal(); // redundant with addAuthStateListener

        this.b3.addEventListener("click", async () => {
            const event = new CustomEvent("hb-treasury", {
                detail: {
                    isShow: false
                },
                bubbles: true,
                composed: true
            });
            //this.dispatchEvent(event);
            //window.location.hash = "#/vault/mint"; //#/onboard/start; data-drawer-show

            if (
                confirm(
                    "⚡️ Would you like a Happiness Energy Boost for your ❤️ ?"
                )
            ) {
                this.showSpinner();
                const token = await this.tokens.getChest(
                    this.heartbank.user?.uid || ""
                );
                if (token.cursor) window.tokenCursor = token.cursor;
                this.hideSpinner();

                if (token.data) {
                    history.pushState(
                        null,
                        "",
                        `#/token/${token.data.id}/chest`
                    );
                    this.showToken(token.data, "chest", "0", false);
                    //window.location.hash = `#/token/${token.data.id}/chest`;
                } else
                    alert(`⚡️ Happiness Energy Boost for your ❤️ coming soon!`);

                this.functions.admin(
                    "⚡️ Happiness Energy Boost",
                    "❤️‍🔥 Zero Hero has received a Happiness Energy Boost!"
                );
            } else {
                this.showSpinner();
                const moment = await this.kiitti.getRock(
                    this.heartbank.user?.uid || ""
                );
                if (moment.cursor) window.momentCursor = moment.cursor;
                this.hideSpinner();

                if (moment.data) {
                    history.pushState(null, "", `#/aquarius/${moment.data.id}`);
                    this.showDear(moment.data, false);
                    //window.location.hash = `#/aquarius/${moment.data.id}`;
                } else
                    alert(`⚡️ Positive Energy Boost for your ❤️ coming soon!`);

                this.functions.admin(
                    "⚡️ Positive Energy Boost",
                    "❤️‍🔥 Zero Hero has received a Positive Energy Boost!"
                );
            }

            // const moment = await this.kiitti.getRock(
            //     this.heartbank.user?.uid || ""
            // );
            // if (moment.cursor) window.tokenCursor = moment.cursor;
            // window.location.hash = moment.data
            //     ? `#/aquarius/${moment.data.id}`
            //     : "#/aquarius";
        });

        this.b.addEventListener("click", () => {
            const event = new CustomEvent("hb-treasury", {
                detail: {
                    isShow: false
                },
                bubbles: true,
                composed: true
            });
            //this.dispatchEvent(event);
            //window.location.hash = "#/vault/mint";
            //alert(`⚡️ Happiness Energy Boost for your ❤️ coming soon!`);
        });

        this.heartbank.addAuthStateListener((user) => {
            //render(template(user), this);
            if (user) this.showMainChest(user);
            else this.showCrystal(); // "glb" // add format to download crystal
            this.hideSpinner();
        });
    }

    showCrystal(format: "glb" | "usdz" | null = null) {
        // download crystal
        if (format) {
            this.crystal.isRainbow = false;
            this.crystal.setKarat("silver");
            this.crystal.exportModel(format);
        }

        //this.b.rainbow = false;
        //this.b.heartbeat = false;
        //this.b.render = "none";

        this.crystal.startAnimation(true);
        this.b.classList.add("hidden"); // weird bug: doesn't work
        this.b.style.display = "none";
        this.b3.classList.remove("hidden");
    }

    async showMainChest(user: User) {
        this.crystal.stopAnimation();
        this.b.classList.remove("hidden"); // weird bug: doesn't work
        this.b.style.display = "";
        this.b3.classList.add("hidden");

        this.b.karat = "silver";
        this.b.rainbow = true;
        this.b.heartbeat = true;
        this.b.render = "avatar";
        await wait(1); // needed for first signup bc user doc created //TODO: later find precise way than waiting
        this.b.renderAvatar(user);
    }

    updatePhoto(url: string) {
        this.b.updatePhoto(url);
    }

    showMap() {}

    openHB(extension: string, endpoint: string) {
        this.popup.openHB(extension, endpoint);
    }

    openThank(extension: string, endpoint: string) {
        this.popup.openThank(extension, endpoint);
    }

    showB(user: User | null = null) {
        this.b.show(user);
    }

    hideB() {
        this.b.hide();
    }

    showSpinner() {
        this.spinner.classList.remove("hidden");
    }

    hideSpinner() {
        this.spinner.classList.add("hidden");
    }

    ////

    showVideo(page: string) {
        this.video.show(page);
    }

    hideVideo() {
        this.video.hide();
    }

    showVault(type: "mint" | "mine") {
        this.vault.show(type);
    }

    backVault(page: "mint" | "mine") {
        this.vault.back(page);
    }

    hideVault() {
        this.vault.hide();
    }

    ///

    showShip() {
        this.ship.show();
    }

    hideShip() {
        this.ship.hide();
    }

    renderShip(user: User | null) {
        this.ship.render(user);
    }

    showSilver() {
        this.silver.show();
    }

    hideSilver() {
        this.silver.hide();
    }

    renderSilver(user: User | null) {
        this.silver.render(user);
    }

    showJewel() {
        this.jewel.show();
    }

    hideJewel() {
        this.jewel.hide();
    }

    showX(id: string) {
        this.x.show(id);
    }

    hideX() {
        this.x.hide();
    }

    renderX(user: User | null) {
        this.x.render(user);
    }

    showMine(id: string) {
        this.mine.show(id);
    }

    hideMine() {
        this.dear.hide();
    }

    showDear(id: string | Moment, isBoost: boolean) {
        this.dear.show(id, isBoost);
    }

    hideDear() {
        this.dear.hide();
    }

    //

    showPixxiKat(category: string, item: string) {
        this.pixxikat.show(category, item);
    }

    hidePixxiKat() {
        this.pixxikat.hide();
    }

    showEmoji(category: string, item: string) {
        this.emoji.show(category, item);
    }

    hideEmoji() {
        this.gif.hide();
    }

    showGif(category: string, item: string) {
        this.gif.show(category, item);
    }

    hideGif() {
        this.gif.hide();
    }

    showLeaderboard() {
        this.leaderboard.show();
    }

    hideLeaderboard() {
        this.video.hide();
    }

    showThank(id: string) {
        this.thank.show(id);
    }

    hideThank() {
        this.thank.hide();
    }

    showToken(id: string | Token, uid: string, isTap: string, isBank: boolean) {
        this.token.show(id, uid, isTap, isBank);
    }

    hideToken() {
        this.token.hide();
    }

    tip(miner: any, note: string) {
        this.token.tip(miner, note);
    }

    ///

    showPost(id: string) {
        this.post.show(id);
    }

    hidePost() {
        this.post.hide();
    }

    showLink(url: string) {
        this.link.show(url);
    }

    hideLink() {
        this.link.hide();
    }

    showTrove(id: string) {
        this.trove.show(id);
    }

    hideTrove() {
        this.trove.hide();
    }
}
